import { useEffect } from "react";
import { Button, Form, Input, Select } from "antd";

import type { ItfTaxpayer } from "types/taxpayers";

interface Props {
  nameForm: string;
  textSubmit?: string;
  loading?: boolean;
  resetFields?: boolean;
  taxpayer?: ItfTaxpayer | Partial<ItfTaxpayer>;
  handleOnSubmit?: (params: { body: Partial<ItfTaxpayer>; taxpayerId: number }) => void;
}

export function SaveTaxpayerForm(props: Props): JSX.Element {
  const {
    nameForm,
    textSubmit = "Enviar",
    loading = false,
    resetFields = false,
    taxpayer = { id: NaN, is_foreign: 1 },
    handleOnSubmit = () => undefined,
  } = props;

  const [form] = Form.useForm();

  const getInitialValues = (): any => {
    return taxpayer?.id ? { ...taxpayer, is_foreign: !taxpayer?.is_foreign ? 1 : 0 } : taxpayer;
  };

  const onFinish = (values): void => {
    const newValues: Partial<ItfTaxpayer> = {
      ...(taxpayer?.id && taxpayer),
      ...values,
      person_type: "physical",
      is_foreign: !!values.is_foreign,
    };
    handleOnSubmit({ body: newValues, taxpayerId: taxpayer?.id });
  };

  useEffect((): void => {
    if (resetFields) form.resetFields();
  }, [resetFields]);

  return (
    <Form
      form={form}
      name={nameForm}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={null}
      initialValues={getInitialValues()}
    >
      <Form.Item
        name="name"
        label="Nombre completo"
        rules={[
          {
            required: true,
            pattern: /[\w]{1,2}\s.{3,}/i,
            message: "Ingrese nombre y apellidos",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="tax_id"
        label="RFC"
        rules={[{ required: true, pattern: /^[\w]{12,13}$/, message: "De 12 a 13 caracteres alfanuméricos" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="official_id"
        label="Identificación Oficial"
        rules={[{ required: true, pattern: /^[\w]{8,10}$/, message: "De 8 caracteres alfanuméricos" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="is_foreign" label="Nacionalidad" required={true}>
        <Select>
          <Select.Option value={1}>Mexicano</Select.Option>
          <Select.Option value={0}>Extranjero</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        name="full_address"
        label="Dirección completa"
        rules={[{ required: true, min: 6, message: "Campo requerido" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {textSubmit}
        </Button>
      </Form.Item>
    </Form>
  );
}
